import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Seo } from '@/components/Seo';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={t('notFound.seoTitle')} description={t('notFound.subtitle')} noindex />
      <section className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center">
        <span className="font-display text-7xl font-extrabold text-brand glow-text">404</span>
        <h1 className="mt-4 font-display text-2xl font-bold text-white">{t('notFound.title')}</h1>
        <p className="mt-3 max-w-sm text-white/50">{t('notFound.subtitle')}</p>
        <Link to="/" className="btn-primary mt-8">{t('notFound.back')}</Link>
      </section>
    </>
  );
}
